// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");

function SettingsPageHeader(props) {
  return JsxRuntime.jsxs("header", {
    children: [
      JsxRuntime.jsx("h2", {
        children: props.title,
        className: "text-3xl font-medium text-zinc-800"
      }),
      Stdlib_Option.getOr(Stdlib_Option.map(props.description, description => JsxRuntime.jsx("p", {
        children: description,
        className: "max-w-2xl text-base text-zinc-500"
      })), null)
    ],
    className: "space-y-2 border-b border-zinc-200 pb-6"
  });
}

function SettingsPageHeader$SectionHeading(props) {
  return JsxRuntime.jsx("h3", {
    children: props.title,
    className: "text-lg font-semibold text-zinc-800"
  });
}

let SectionHeading = {
  make: SettingsPageHeader$SectionHeading
};

let make = SettingsPageHeader;

exports.make = make;
exports.SectionHeading = SectionHeading;
/* react/jsx-runtime Not a pure module */
